(function() {
    console.log("🚀 GemX A/B Test: Combined Search Started");

    const findAndInjectAll = () => {
        // 1. Find the UpCart Shadow Root by searching all elements
        const allElements = document.querySelectorAll('*');
        let shadow = null;

        for (let el of allElements) {
            if (el.shadowRoot) {
                // We use the checkout button as the "anchor" to know we found the right Shadow DOM
                if (el.shadowRoot.querySelector('[class*="checkoutButton"]')) {
                    shadow = el.shadowRoot;
                    break; 
                }
            }
        }

        if (!shadow) {
            console.log("🔎 Searching for UpCart Shadow DOM...");
            return;
        }

        // --- PART 1: INJECT MOTIVATION BAR ---
        const productSection = shadow.querySelector('.upcart-products-section');
        if (productSection && !shadow.querySelector('.ab-test-motivation-bar')) {
            console.log("✅ Injecting Motivation Bar");
            const motivationBar = document.createElement('div');
            motivationBar.className = 'ab-test-motivation-bar';
            motivationBar.style.cssText = `
                background: #f8f9fa;
                border-radius: 12px;
                padding: 15px;
                margin: 10px 15px;
                display: flex;
                flex-direction: column;
                gap: 10px;
            `;
            motivationBar.innerHTML = `
                <div style="display: flex; align-items: center; gap: 10px;">
                    <img src="https://i.ibb.co/3mH55Mbk/image-8.png" style="width: 24px; height: 24px;" border="0">
                    <span style="font-size: 15px; font-weight: 600; color: #2d3748; font-family: sans-serif;">
                        ¡Felicidades, 1 par + 1 gratis desbloqueado!
                    </span>
                </div>
                <div style="width: 100%; background: #e2e8f0; height: 10px; border-radius: 10px; overflow: hidden;">
                    <div style="width: 100%; background: #c51f4d; height: 100%; border-radius: 10px;"></div>
                </div>
            `;
            productSection.parentNode.insertBefore(motivationBar, productSection);
        }

        // --- PART 2: INJECT TRUST BADGES ---
        const checkoutBtn = shadow.querySelector('[class*="checkoutButton"]');
        if (checkoutBtn && !shadow.querySelector('.gemx-trust-badges')) {
            console.log("✅ Injecting Trust Badges");
            const wrapper = document.createElement('div');
            wrapper.className = 'gemx-trust-badges';
            wrapper.style.cssText = `
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 5px;
                margin-bottom: 12px;
                width: 100%;
            `;
            wrapper.innerHTML = `
                <div style="display: flex; align-items: center; gap: 8px; width: 50%;">
                    <img src="https://i.ibb.co/sdv2snDd/Background-Shadow.png" style="width: 35px; height: 35px;">
                    <span style="font-size: 12px; color: #374151; font-weight: 500; line-height: 1.2;">ENTREGA EN 6-8 DÍAS</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px; width: 50%;">
                    <img src="https://i.ibb.co/p6wvBCvC/Background-Shadow-1.png" style="width: 35px; height: 35px;">
                    <span style="font-size: 12px; color: #374151; font-weight: 500; line-height: 1.2;">GARANTÍA DE REEMBOLSO</span>
                </div>
            `;
            checkoutBtn.parentNode.insertBefore(wrapper, checkoutBtn);
        }
    };

    // Run interval to catch cart opening/refreshing
    const timer = setInterval(findAndInjectAll, 1000);
    
    // Safety: stop after 60 seconds of searching
    setTimeout(() => clearInterval(timer), 60000);
})();